<template>
  <BaseModal>
    <template v-slot:modalContent>
      <div class="row" v-for="item in dados">
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>ID Log:</strong></label>
            <p>{{ item.id }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>Módulo:</strong></label>
            <p>{{ item.content_type }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>Ação:</strong></label>
            <p>{{ item.action }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>Data:</strong></label>
            <p>{{ item.timestamp }}</p>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label><strong>Descrição:</strong></label>
            <p>{{ item.object_repr }}</p>
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-md-12 overflow-auto" style="max-height: 500px">
          <table class="table table-hover">
            <thead class="table table-hover">
            <tr>
              <th>#</th>
              <th>CAMPO</th>
              <th>ANTES</th>
              <th>DEPOIS</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in dados" :key="index">
              <template v-for="(valores, campo) in item.changes">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ campo }}</td>
                  <td>{{ valores[0] }}</td>
                  <td>{{ valores[1] }}</td>
                </tr>
              </template>
            </template>

            </tbody>
          </table>
        </div>
      </div>
      <div class="ibox-footer">
        <button class="btn btn-success font-bold" @click="$emit('fechar')">
          Fechar
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes"


export default {
  name: "InformacoesAuditoria",
  components: {
    BaseModal,
  },
  props: {
    itemSelect: Number,
  },
  data() {
    return {
      dados: 1,
      erro: null,
    };
  },
  emits: ['fechar'],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", apiUrl.auditoria.retrieve(this.itemSelect));
      if (resultado.success) {
        this.dados = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
